import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { StyledMarkdown } from "components/shared/styled-markdown/styled-markdown";
import { CaseStudies } from "data/models";

interface CatalogueEntryCaseStudiesProps {
  caseStudies?: CaseStudies[];
}

export const CatalogueEntryCaseStudies = ({
  caseStudies,
}: CatalogueEntryCaseStudiesProps) => {
  if (!caseStudies) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Use Cases</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        {caseStudies.map((c, i) => (
          <div key={i}>
            {i > 0 && <Separator className="mb-6" />}
            <div className="space-y-3">
              <h3 className="text-sm font-semibold">{c.title}</h3>
              <div className="text-sm text-muted-foreground">
                <StyledMarkdown>{c.description}</StyledMarkdown>
              </div>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};
